export default __webpack_public_path__ + "static/media/c.419c6064.mp3";